import { ref, reactive, computed, watch, onMounted } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "title-box"
};
const _hoisted_2 = {
  class: "footer-box"
};
const _hoisted_3 = {
  key: 0,
  class: "area"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "bottom-line"
}, null, -1);
const _hoisted_6 = {
  class: "adjust"
};
const _hoisted_7 = {
  class: "adjust-tips"
};
const _hoisted_8 = {
  class: "taxRateBox"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "rate-tips"
}, "开启后新加坡本地价格将自动上调9%，以规避新加坡地区GST税费", -1);
const _hoisted_10 = {
  key: 1,
  class: "manage"
};
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createTextVNode(" 你可以为支付当前App Store所示订阅价格的现有订阅者保持当前价格,同时针对新订阅者上调价格。 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 如果你选择应用价格上调且不为现有订阅者保持当前价格,则现有订阅者可能需要同意价格上调。 ")], -1);
import { WarningFilled } from '@ant-design/icons-vue';
import { getNode } from '@/common';
import PriceBlockConsume from './PriceBlockConsume.vue';
import useEditHooks from '../hooks/useEditHooks';
import { useRoute } from 'vue-router';
import { cloneDeep } from 'lodash';
// import type { RoleItem } from '../data'
// import { createRole, editRole } from '@/api/user'
export default /*#__PURE__*/_defineComponent({
  __name: 'EditModal',
  props: {
    goodsInfo: null,
    areaList: null,
    originPriceList: null,
    showRateSwitch: null,
    taxRateSwitch: null
  },
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    // 定义emits
    // 路由值
    const route = useRoute();
    const baseCountryInfo = ref('');
    // const priceBlockRef = ref<any>(null)
    const {
      defaultCountryId,
      settingForm,
      defaultCountry,
      conturyPriceLoading,
      conturyPrice,
      queryParams,
      priceBlockRef,
      modalTaxSwitch,
      filterOption,
      calcSelectOptions,
      changeProdPrice,
      getCountryCoinOptions,
      getPkg
    } = useEditHooks();
    // 弹框变量
    const myModal = reactive({
      title: '选取国家或地区',
      step: 1,
      visible: false
    });
    const areaList = ref([{
      indeterminate: false,
      checkAll: true,
      name: '全部',
      checkedList: [],
      options: []
    }]);
    const useAreaList = computed(() => {
      var _areaList$value;
      return ((_areaList$value = areaList.value) === null || _areaList$value === void 0 || (_areaList$value = _areaList$value[0]) === null || _areaList$value === void 0 ? void 0 : _areaList$value.checkedList) || [];
    });
    const formRef = ref();
    const loading = ref(false);
    const choose = ref(1);
    // 打开弹窗
    const openModal = async () => {
      Object.assign(myModal, {
        title: '选取国家或地区',
        step: 1
      });
      areaList.value[0].checkedList = props.areaList;
      areaList.value[0].options = props.areaList;
      myModal.visible = true;
    };
    const hanlderOperate = type => {
      switch (type) {
        case 'cancle':
          closeModal();
          break;
        case 'next':
          hanlderOk();
          break;
      }
    };
    const hanlderOk = async () => {
      var _priceBlockRef$value;
      switch (myModal.step) {
        case 1:
          myModal.step++;
          myModal.title = '安排价格调整';
          settingForm.value = cloneDeep(props.goodsInfo);
          await getCountryCoinOptions();
          await getPkg();
          await calcSelectOptions();
          await changeProdPrice(props.goodsInfo.defaultPriceTier, true);
          (_priceBlockRef$value = priceBlockRef.value) === null || _priceBlockRef$value === void 0 || _priceBlockRef$value.init(props.goodsInfo);
          break;
        case 2:
          myModal.title = '管理当前价格';
          let isGrown = false;
          // 判断当前基准国家是否涨价-用defaultCountryId去匹配props.originPriceList的值根据settingForm.defaultPriceTier跟prodPrice比较即可
          const baseCountry = props.originPriceList.find(ls => ls.regionCode === defaultCountryId.value);
          baseCountryInfo.value = cloneDeep(baseCountry);
          baseCountryInfo.value = Object.assign({}, baseCountryInfo.value, {
            prodPrice: settingForm.value.defaultPriceTier,
            priceId: settingForm.value.defaultPriceId,
            startDate: null,
            preserveCurrentPrice: null
          });
          // 判断基准国家是否涨价
          if (baseCountry && Number(baseCountry.prodPrice) < Number(settingForm.value.defaultPriceTier)) {
            isGrown = true;
          }
          // 判断要涨价国家基于基准价格改变后是否涨价
          for (const item of (_priceBlockRef$value2 = priceBlockRef.value) === null || _priceBlockRef$value2 === void 0 ? void 0 : _priceBlockRef$value2.originData) {
            var _priceBlockRef$value2;
            const matched = props.originPriceList.find(ls => ls.regionName === item.regionName);
            // 有一个国家涨价了就终止循环
            if (matched && Number(item.prodPrice) > Number(matched.prodPrice)) {
              isGrown = true;
              break;
            }
          }
          if (isGrown) {
            myModal.step++;
          } else {
            handlePriceInfo(1);
          }
          break;
        case 3:
          handlePriceInfo(2);
          break;
      }
    };
    // 关闭弹窗
    const closeModal = () => {
      // myModal.visible = false
      myModal.visible = false;
      // 重置表单数据
      // Object.assign(myForm, {
      //   roleName: '',
      //   roleCode: '',
      // })
      // 清除表单验证状态
      // formRef.value?.resetFields()
    };
    const onCheckAllChange = (e, index) => {
      const group = areaList.value[index];
      if (e.target.checked) {
        group.checkedList = [...group.options]; // 全选
      } else {
        group.checkedList = []; // 取消全选
      }
      group.checkAll = e.target.checked;
      group.indeterminate = false;
    };
    const clearAllGroups = () => {
      areaList.value.forEach(group => {
        group.checkedList = [];
        group.checkAll = false;
        group.indeterminate = false;
      });
    };
    const handlePriceInfo = type => {
      var _priceBlockRef$value3;
      const priceInfo = ((_priceBlockRef$value3 = priceBlockRef.value) === null || _priceBlockRef$value3 === void 0 ? void 0 : _priceBlockRef$value3.originData) || [];
      // 勾选国家中没有基准国家 需要人为插入展示
      const matched = priceInfo.find(ls => ls.regionName === baseCountryInfo.value.regionName);
      if (!matched) {
        priceInfo.push(baseCountryInfo.value);
      }
      const preserveCurrentPrice = type == 1 ? null : choose.value == 1 ? true : false;
      emit('sendNextPriceData', {
        regionCode: defaultCountryId.value,
        prodPrice: settingForm.value.defaultPriceTier,
        prodPriceCurrency: settingForm.value.prodPriceCurrency,
        defaultPriceId: settingForm.value.defaultPriceId,
        nextProductNativePrice: priceInfo,
        preserveCurrentPrice: preserveCurrentPrice
      });
      closeModal();
    };
    const sureDisabled = computed(() => {
      if (myModal.step !== 1) return false;
      const firstArea = areaList.value[0];
      return !firstArea || firstArea.checkedList.length === 0;
    });
    // 处理下拉框change事件，不直接修改下拉值
    const handlePriceTierChange = async () => {
      await changeProdPrice(settingForm.value.defaultPriceTier);
    };
    // 监听每个分组的 checkedList 变化
    watch(() => areaList.value.map(g => g.checkedList), () => {
      // 遍历每个分组，更新 indeterminate 和 checkAll
      areaList.value.forEach(group => {
        const checkedCount = group.checkedList.length;
        const total = group.options.length;
        group.indeterminate = checkedCount > 0 && checkedCount < total;
        group.checkAll = checkedCount === total;
      });
    }, {
      deep: true
    });
    // 监听 props.taxRateSwitch 变化并赋值给 modalTaxSwitch
    watch(() => props.taxRateSwitch, newVal => {
      if (newVal !== undefined) {
        modalTaxSwitch.value = newVal;
      }
    }, {
      immediate: true
    });
    onMounted(async () => {
      queryParams.value = {
        ...route.query
      };
    });
    // 暴露方法给父组件
    expose({
      openModal,
      closeModal
    });
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      const _component_a_checkbox_group = _resolveComponent("a-checkbox-group");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_switch = _resolveComponent("a-switch");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_radio = _resolveComponent("a-radio");
      const _component_a_radio_group = _resolveComponent("a-radio-group");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: myModal.visible,
        "onUpdate:open": _cache[6] || (_cache[6] = $event => myModal.visible = $event),
        closable: false,
        width: "620px",
        confirmLoading: loading.value,
        centered: "",
        class: "goods-modal-content"
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(myModal.title), 1)]),
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_button, {
          onClick: _cache[0] || (_cache[0] = $event => hanlderOperate('cancle'))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_a_button, {
          onClick: _cache[1] || (_cache[1] = $event => hanlderOperate('next')),
          disabled: _unref(sureDisabled)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(myModal.step > 2 ? '确认' : '下一步'), 1)]),
          _: 1
        }, 8, ["disabled"])])]),
        default: _withCtx(() => [myModal.step == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(areaList.value, (group, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "area-box"
          }, [_createVNode(_component_a_checkbox, {
            indeterminate: group.indeterminate,
            checked: group.checkAll,
            onChange: e => onCheckAllChange(e, index)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(group.name) + "(" + _toDisplayString(group.options.length) + ") ", 1)]),
            _: 2
          }, 1032, ["indeterminate", "checked", "onChange"]), _hoisted_4, _createVNode(_component_a_checkbox_group, {
            value: group.checkedList,
            "onUpdate:value": $event => group.checkedList = $event,
            options: group.options,
            style: {
              "display": "block",
              "margin-top": "8px"
            }
          }, null, 8, ["value", "onUpdate:value", "options"]), _hoisted_5]);
        }), 128))])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_unref(WarningFilled)), _createTextVNode(" 若对应国家或地区价格下调,新老用户均将直接以更低的新价格订阅或续订 ")]), _createVNode(_component_a_form, {
          ref_key: "formRef",
          ref: formRef,
          class: "com-modal-body-padding",
          model: _unref(settingForm),
          "label-col": {
            span: 5
          },
          "wrapper-col": {
            span: 15
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "默认价格",
            name: "defaultPriceTier",
            rules: [{
              required: true
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              getPopupContainer: _unref(getNode),
              class: "selecter",
              value: _unref(defaultCountryId),
              "onUpdate:value": _cache[2] || (_cache[2] = $event => _isRef(defaultCountryId) ? defaultCountryId.value = $event : null),
              placholder: "请选择语言",
              "filter-option": _unref(filterOption),
              style: {
                "width": "140px",
                "margin-right": "12px"
              },
              onChange: _unref(calcSelectOptions),
              "show-search": "",
              options: _unref(defaultCountry),
              "field-names": {
                label: 'regionName',
                value: 'regionCode'
              }
            }, null, 8, ["getPopupContainer", "value", "filter-option", "onChange", "options"]), _createVNode(_component_a_select, {
              class: "selecter",
              "show-search": "",
              value: _unref(settingForm).defaultPriceTier,
              "onUpdate:value": _cache[3] || (_cache[3] = $event => _unref(settingForm).defaultPriceTier = $event),
              style: {
                "width": "140px",
                "display": "inline-block"
              },
              placholder: "请选择价格",
              onChange: _unref(changeProdPrice),
              loading: _unref(conturyPriceLoading),
              "field-names": {
                label: 'prodPrice',
                value: 'prodPrice'
              },
              options: _unref(conturyPrice)
            }, null, 8, ["value", "onChange", "loading", "options"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "本地价格",
            rules: [{
              required: true
            }]
          }, {
            default: _withCtx(() => [_createVNode(PriceBlockConsume, {
              "prod-type": _unref(settingForm).prodType,
              dbtId: _unref(queryParams).dbtId,
              "prod-chnl": _unref(queryParams).prodChnl,
              "prod-price-currency": _unref(settingForm).prodPriceCurrency,
              "area-list": _unref(useAreaList),
              taxRateSwitch: _unref(modalTaxSwitch),
              ref_key: "priceBlockRef",
              ref: priceBlockRef,
              onUpdateList: _unref(changeProdPrice)
            }, null, 8, ["prod-type", "dbtId", "prod-chnl", "prod-price-currency", "area-list", "taxRateSwitch", "onUpdateList"])]),
            _: 1
          }), __props.showRateSwitch ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 0,
            label: "GST调价"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_a_switch, {
              checked: _unref(modalTaxSwitch),
              "onUpdate:checked": _cache[4] || (_cache[4] = $event => _isRef(modalTaxSwitch) ? modalTaxSwitch.value = $event : null),
              disabled: _unref(conturyPriceLoading),
              onChange: handlePriceTierChange
            }, null, 8, ["checked", "disabled"]), _hoisted_9])]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model"])], 512), [[_vShow, myModal.step == 2]]), myModal.step == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_hoisted_11, _createVNode(_component_a_radio_group, {
          value: choose.value,
          "onUpdate:value": _cache[5] || (_cache[5] = $event => choose.value = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_a_radio, {
            style: {
              "display": "flex",
              "align-items": "center"
            },
            value: 1
          }, {
            default: _withCtx(() => [_createTextVNode("为现有订阅者保持当前价格")]),
            _: 1
          }), _createVNode(_component_a_radio, {
            style: {
              "display": "flex",
              "align-items": "center"
            },
            value: 2
          }, {
            default: _withCtx(() => [_createTextVNode("将价格上调应用于现有订阅者")]),
            _: 1
          })]),
          _: 1
        }, 8, ["value"])])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["open", "confirmLoading"]);
    };
  }
});